import React, { useEffect, useState } from 'react';

const weatherIcons = {
  0: "☀️", 1: "🌤️", 2: "⛅", 3: "☁️",
  45: "🌫️", 48: "🌫️", 51: "🌦️", 53: "🌦️", 55: "🌧️",
  61: "🌧️", 63: "🌧️", 65: "🌧️", 80: "🌧️", 81: "🌧️", 82: "🌧️",
  95: "⛈️", 96: "⛈️", 99: "⛈️",
};

const weatherDescriptions = {
  0: "Trời quang", 1: "Gần như trời quang", 2: "Trời có mây", 3: "Trời nhiều mây",
  45: "Sương mù", 48: "Sương mù đóng băng", 51: "Mưa phùn nhẹ", 53: "Mưa phùn vừa", 55: "Mưa phùn dày",
  61: "Mưa nhẹ", 63: "Mưa vừa", 65: "Mưa to", 80: "Mưa rào nhẹ", 81: "Mưa rào vừa", 82: "Mưa rào rất to",
  95: "Dông nhẹ", 96: "Dông có mưa đá nhẹ", 99: "Dông có mưa đá lớn",
};

export default function Weather() {
  const [weather, setWeather] = useState(null);

  // Load cache từ localStorage nếu có
  useEffect(() => {
    const cachedWeather = localStorage.getItem("cachedWeather");
    if (cachedWeather) {
      setWeather(JSON.parse(cachedWeather));
    }

    // Fetch dữ liệu mới
    fetch('https://api.open-meteo.com/v1/forecast?latitude=10.7008&longitude=106.9126&current_weather=true')
      .then(res => res.json())
      .then(data => {
        const currentWeather = data.current_weather;
        setWeather(currentWeather);
        localStorage.setItem("cachedWeather", JSON.stringify(currentWeather));
      })
      .catch(console.error);
  }, []);

  if (!weather) return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-halloween-orange/30 shadow-halloween-purple/10 w-[320px]">
      <h2 className="text-lg font-bold mb-2">Thời tiết Nhơn Trạch</h2>
      <p className="text-gray-500">Đang cập nhật…</p>
    </div>
  );

  const icon = weatherIcons[weather.weathercode] || "🌤️";
  const description = weatherDescriptions[weather.weathercode] || "Không xác định";

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-halloween-orange/30 shadow-halloween-purple/10 w-full">
      <h2 className="text-xl font-bold mb-2">Thời tiết Nhơn Trạch</h2>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-700">{description}</p>
          <p className="text-sm text-gray-700">Nhiệt độ: {weather.temperature}°C</p>
          <p className="text-sm text-gray-700">Gió: {weather.windspeed} km/h</p>
        </div>
        <div className="text-5xl mr-4">{icon}</div>
      </div>
    </div>
  );
}
